import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

type HoverTooltipProps = {
  content?: React.ReactNode
  className?: string
  children: React.ReactNode
}

export function HoverTooltip({ content, className, children }: HoverTooltipProps) {
  if (!content) {
    return <></>
  }

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className={`bg-white ${className || ''}`}>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
